export const iconContainerStyles = `
   w-[40px] h-[40px] p-[10px]
   rounded-full 
   cursor-pointer 
   absolute top-[16px] right-0
`

export const errorBoundaryContainerStyles = `
   w-[calc(100%_-_40px)] rounded-[16px]
`
